// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__kNLli","Project__showcase":"Project_Project__showcase__8IJ2-"};